export default "__VITE_ASSET__BKdGd85x__"